const todoNotificationTranslations = {
	todoLoadMore: {
		en: "Load more", ru: "Загрузить ещё", hy: "Բեռնել ավելին", tr: "Daha fazla yükle",
		ar: "تحميل المزيد", zh: "加载更多", fa: "بارگیری بیشتر", he: "טעינת נוספים",
		fr: "Charger plus", es: "Cargar más", pt: "Carregar mais"
	},
	todoMuteNotifications: {
		en: "Mute notifications", ru: "Отключить уведомления", hy: "Անջատել ծանուցումները",
		tr: "Bildirimleri sessize al", ar: "كتم الإشعارات", zh: "静音通知",
		fa: "بی‌صدا کردن اعلان‌ها", he: "השתקת התראות", fr: "Désactiver les notifications",
		es: "Silenciar notificaciones", pt: "Silenciar notificações"
	},
	todoUnmuteNotifications: {
		en: "Unmute notifications", ru: "Включить уведомления", hy: "Միացնել ծանուցումները",
		tr: "Bildirimlerin sesini aç", ar: "إلغاء كتم الإشعارات", zh: "取消静音通知",
		fa: "فعال کردن صدای اعلان‌ها", he: "ביטול השתקת התראות", fr: "Réactiver les notifications",
		es: "Activar notificaciones", pt: "Ativar notificações"
	},
	todoMuteFor: {
		en: "Mute notifications for", ru: "Отключить уведомления на", hy: "Անջատել ծանուցումները՝",
		tr: "Bildirimleri şu süreyle sessize al", ar: "كتم الإشعارات لمدة", zh: "静音通知时长",
		fa: "بی‌صدا کردن اعلان‌ها برای", he: "השתקת התראות למשך", fr: "Désactiver les notifications pendant",
		es: "Silenciar notificaciones durante", pt: "Silenciar notificações por"
	},
	todoMuteForever: {
		en: "Forever", ru: "Навсегда", hy: "Ընդմիշտ", tr: "Süresiz", ar: "إلى الأبد",
		zh: "永久", fa: "برای همیشه", he: "לתמיד", fr: "Indéfiniment", es: "Para siempre", pt: "Para sempre"
	},
	todoCustomMinutes: {
		en: "Custom duration (minutes)", ru: "Своя длительность (минуты)", hy: "Այլ տևողություն (րոպե)",
		tr: "Özel süre (dakika)", ar: "مدة مخصصة (بالدقائق)", zh: "自定义时长（分钟）",
		fa: "مدت سفارشی (دقیقه)", he: "משך מותאם (דקות)", fr: "Durée personnalisée (minutes)",
		es: "Duración personalizada (minutos)", pt: "Duração personalizada (minutos)"
	},
	todoMutedUntil: {
		en: "Muted until", ru: "Отключено до", hy: "Անջատված է մինչև", tr: "Şu zamana kadar sessizde",
		ar: "مكتوم حتى", zh: "静音至", fa: "بی‌صدا تا", he: "מושתק עד", fr: "Désactivées jusqu’au",
		es: "Silenciadas hasta", pt: "Silenciadas até"
	},
	todoMutedForever: {
		en: "Muted forever", ru: "Отключено навсегда", hy: "Անջատված է ընդմիշտ",
		tr: "Süresiz sessizde", ar: "مكتوم إلى الأبد", zh: "永久静音",
		fa: "برای همیشه بی‌صدا", he: "מושתק לתמיד", fr: "Désactivées indéfiniment",
		es: "Silenciadas para siempre", pt: "Silenciadas para sempre"
	},
	todoNotificationsMuted: {
		en: "Notifications muted", ru: "Уведомления отключены", hy: "Ծանուցումներն անջատված են",
		tr: "Bildirimler sessize alındı", ar: "تم كتم الإشعارات", zh: "通知已静音",
		fa: "اعلان‌ها بی‌صدا شدند", he: "ההתראות הושתקו", fr: "Notifications désactivées",
		es: "Notificaciones silenciadas", pt: "Notificações silenciadas"
	},
	todoNotificationsUnmuted: {
		en: "Notifications unmuted", ru: "Уведомления включены", hy: "Ծանուցումները միացված են",
		tr: "Bildirimlerin sesi açıldı", ar: "تم إلغاء كتم الإشعارات", zh: "通知已取消静音",
		fa: "صدای اعلان‌ها فعال شد", he: "השתקת ההתראות בוטלה", fr: "Notifications réactivées",
		es: "Notificaciones activadas", pt: "Notificações ativadas"
	},
	todoNotificationMuteFailed: {
		en: "Could not update notification mute", ru: "Не удалось изменить настройку уведомлений", hy: "Չհաջողվեց փոխել ծանուցումների անջատման կարգավորումը",
		tr: "Bildirim sessize alma ayarı güncellenemedi", ar: "تعذر تحديث إعداد كتم الإشعارات", zh: "无法更新通知静音设置",
		fa: "تنظیم بی‌صدا کردن اعلان به‌روزرسانی نشد", he: "לא ניתן לעדכן את השתקת ההתראות", fr: "Impossible de modifier la désactivation des notifications",
		es: "No se pudo actualizar el silencio de las notificaciones", pt: "Não foi possível atualizar o silenciamento das notificações"
	},
	todoEmptyColumnNotifications: {
		en: "Empty-column notifications", ru: "Уведомления о пустом столбце", hy: "Դատարկ սյունակի ծանուցումներ",
		tr: "Boş sütun bildirimleri", ar: "إشعارات العمود الفارغ", zh: "空列通知",
		fa: "اعلان‌های ستون خالی", he: "התראות על עמודה ריקה", fr: "Notifications de colonne vide",
		es: "Notificaciones de columna vacía", pt: "Notificações de coluna vazia"
	},
	todoNotifyWhenColumnEmpty: {
		en: "Notify when this column stays empty", ru: "Уведомлять, если столбец остаётся пустым", hy: "Ծանուցել, երբ այս սյունակը մնում է դատարկ",
		tr: "Bu sütun boş kaldığında bildir", ar: "الإشعار عندما يظل هذا العمود فارغًا", zh: "此列持续为空时通知",
		fa: "وقتی این ستون خالی می‌ماند اطلاع بده", he: "להודיע כאשר העמודה נשארת ריקה", fr: "Notifier lorsque cette colonne reste vide",
		es: "Notificar cuando esta columna permanezca vacía", pt: "Notificar quando esta coluna permanecer vazia"
	},
	todoEmptyForMinutes: {
		en: "Empty time (minutes)", ru: "Время без задач (минуты)", hy: "Դատարկ մնալու ժամանակը (րոպե)",
		tr: "Boş kalma süresi (dakika)", ar: "مدة الفراغ (بالدقائق)", zh: "空置时间（分钟）",
		fa: "مدت خالی بودن (دقیقه)", he: "משך הזמן הריק (דקות)", fr: "Durée à vide (minutes)",
		es: "Tiempo vacía (minutos)", pt: "Tempo vazia (minutos)"
	},
	todoEmptyForMinutesDescription: {
		en: "Send the alert after the column has had no active task cards for this long.",
		ru: "Отправить предупреждение, если в столбце нет активных карточек задач в течение этого времени.",
		hy: "Ուղարկել ազդանշանը, երբ այսքան ժամանակ սյունակում ակտիվ առաջադրանքների քարտեր չեն եղել։",
		tr: "Sütunda bu süre boyunca etkin görev kartı olmadığında uyarı gönder.",
		ar: "إرسال التنبيه بعد خلو العمود من بطاقات المهام النشطة طوال هذه المدة.",
		zh: "当此列在该时长内没有活动任务卡时发送提醒。",
		fa: "اگر ستون در این مدت کارت وظیفه فعالی نداشت، هشدار ارسال شود.",
		he: "שליחת התראה לאחר שלא היו בעמודה כרטיסי משימה פעילים במשך זמן זה.",
		fr: "Envoyer l’alerte lorsque la colonne ne contient aucune tâche active pendant cette durée.",
		es: "Enviar la alerta cuando la columna no tenga tarjetas de tareas activas durante este tiempo.",
		pt: "Enviar o alerta quando a coluna ficar sem cartões de tarefas ativos durante esse período."
	},
	todoAdditionalNotifyUsers: {
		en: "Additional users to notify", ru: "Дополнительные получатели", hy: "Լրացուցիչ ծանուցվող օգտատերեր",
		tr: "Bildirilecek ek kullanıcılar", ar: "مستخدمون إضافيون لإشعارهم", zh: "额外通知用户",
		fa: "کاربران اضافی برای اطلاع‌رسانی", he: "משתמשים נוספים לעדכון", fr: "Utilisateurs supplémentaires à notifier",
		es: "Usuarios adicionales que notificar", pt: "Usuários adicionais para notificar"
	},
	todoAdditionalNotifyUsersDescription: {
		en: "Only board members can be selected. Responsible users are included automatically.",
		ru: "Можно выбрать только участников доски. Ответственные пользователи добавляются автоматически.",
		hy: "Կարելի է ընտրել միայն տախտակի անդամներին։ Պատասխանատու օգտատերերը ներառվում են ավտոմատ։",
		tr: "Yalnızca pano üyeleri seçilebilir. Sorumlu kullanıcılar otomatik olarak eklenir.",
		ar: "يمكن اختيار أعضاء اللوحة فقط. تتم إضافة المستخدمين المسؤولين تلقائيًا.",
		zh: "只能选择看板成员。负责人会自动包含。",
		fa: "فقط اعضای برد قابل انتخاب هستند. کاربران مسئول به‌طور خودکار اضافه می‌شوند.",
		he: "ניתן לבחור רק חברי לוח. המשתמשים האחראים נכללים אוטומטית.",
		fr: "Seuls les membres du tableau peuvent être sélectionnés. Les responsables sont inclus automatiquement.",
		es: "Solo se pueden seleccionar miembros del tablero. Los responsables se incluyen automáticamente.",
		pt: "Somente membros do quadro podem ser selecionados. Os responsáveis são incluídos automaticamente."
	},
	todoResponsibleAlwaysNotified: {
		en: "Responsible users are always notified", ru: "Ответственные пользователи всегда получают уведомление", hy: "Պատասխանատու օգտատերերը միշտ ծանուցվում են",
		tr: "Sorumlu kullanıcılar her zaman bilgilendirilir", ar: "يتم إشعار المستخدمين المسؤولين دائمًا", zh: "负责人始终会收到通知",
		fa: "کاربران مسئول همیشه مطلع می‌شوند", he: "המשתמשים האחראים תמיד מקבלים התראה", fr: "Les responsables sont toujours notifiés",
		es: "Los responsables siempre reciben una notificación", pt: "Os responsáveis são sempre notificados"
	},
	todoEmptyColumnBypassesMute: {
		en: "This deadline alert has priority and is delivered even when the board or task is muted.",
		ru: "Это срочное предупреждение имеет приоритет и доставляется, даже если уведомления доски или задачи отключены.",
		hy: "Այս վերջնաժամկետային ազդանշանն առաջնահերթ է և առաքվում է, նույնիսկ եթե տախտակի կամ առաջադրանքի ծանուցումներն անջատված են։",
		tr: "Bu süre uyarısı önceliklidir ve pano veya görev sessize alınmış olsa bile gönderilir.",
		ar: "تنبيه الموعد النهائي هذا له الأولوية ويُرسل حتى عند كتم اللوحة أو المهمة.",
		zh: "此截止提醒具有优先级，即使看板或任务已静音也会发送。",
		fa: "این هشدار مهلت اولویت دارد و حتی در صورت بی‌صدا بودن برد یا وظیفه ارسال می‌شود.",
		he: "התראת מועד זו היא בעדיפות גבוהה ונשלחת גם כשהלוח או המשימה מושתקים.",
		fr: "Cette alerte d’échéance est prioritaire et reste envoyée même si le tableau ou la tâche est désactivé.",
		es: "Esta alerta de plazo tiene prioridad y se envía aunque el tablero o la tarea estén silenciados.",
		pt: "Este alerta de prazo tem prioridade e é enviado mesmo que o quadro ou a tarefa estejam silenciados."
	},
	todoEmptyColumnMinutesRequired: {
		en: "Enter an empty time of at least one minute.", ru: "Укажите время без задач не менее одной минуты.", hy: "Մուտքագրեք առնվազն մեկ րոպե դատարկ մնալու ժամանակ։",
		tr: "En az bir dakikalık boş kalma süresi girin.", ar: "أدخل مدة فراغ لا تقل عن دقيقة واحدة.", zh: "请输入至少一分钟的空置时间。",
		fa: "مدت خالی بودن را حداقل یک دقیقه وارد کنید.", he: "יש להזין זמן ריק של דקה אחת לפחות.", fr: "Saisissez une durée à vide d’au moins une minute.",
		es: "Introduzca un tiempo vacío de al menos un minuto.", pt: "Informe um tempo vazio de pelo menos um minuto."
	},
	todoEmptyColumnRuleSaved: {
		en: "Empty-column notification rule saved", ru: "Правило уведомления о пустом столбце сохранено", hy: "Դատարկ սյունակի ծանուցման կանոնը պահպանվել է",
		tr: "Boş sütun bildirim kuralı kaydedildi", ar: "تم حفظ قاعدة إشعار العمود الفارغ", zh: "空列通知规则已保存",
		fa: "قانون اعلان ستون خالی ذخیره شد", he: "כלל ההתראה על עמודה ריקה נשמר", fr: "Règle de notification de colonne vide enregistrée",
		es: "Regla de notificación de columna vacía guardada", pt: "Regra de notificação de coluna vazia salva"
	},
	todoEmptyColumnRuleSaveFailed: {
		en: "Could not save the empty-column notification rule", ru: "Не удалось сохранить правило уведомления о пустом столбце", hy: "Չհաջողվեց պահպանել դատարկ սյունակի ծանուցման կանոնը",
		tr: "Boş sütun bildirim kuralı kaydedilemedi", ar: "تعذر حفظ قاعدة إشعار العمود الفارغ", zh: "无法保存空列通知规则",
		fa: "قانون اعلان ستون خالی ذخیره نشد", he: "לא ניתן לשמור את כלל ההתראה על עמודה ריקה", fr: "Impossible d’enregistrer la règle de notification de colonne vide",
		es: "No se pudo guardar la regla de notificación de columna vacía", pt: "Não foi possível salvar a regra de notificação de coluna vazia"
	}
};

export default todoNotificationTranslations;
